import React, { createContext, useContext, useState } from "react";

export interface IAccordionObjectFieldContext {
    active?: string;
    toggleItem: (key: string) => void
};

const context = createContext<IAccordionObjectFieldContext | null>(null);
const { Provider } = context;

export const useAccordionObjectFieldContext = () => useContext(context);

// Provider
export const AccordionObjectFieldProvider: React.FC = ({ children }) => {

    const [active, setActive] = useState<string>();

    const toggleItem = (key: string) => {
        setActive((prevKey) => prevKey === key ? undefined : key)
    };

    const value: IAccordionObjectFieldContext = {
        active,
        toggleItem
    };

    return (
        <Provider value={value}>
            {children}
        </Provider>
    );
};
